import { render, staticRenderFns } from "./LangBox.vue?vue&type=template&id=0ae3f61e&"
import script from "./LangBox.vue?vue&type=script&lang=js&"
export * from "./LangBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports